import {AbstractSerializer} from '../../Abstract/Serializer';

export class APIPlatformSerializer extends AbstractSerializer {
  base = '';

  getIRI = value => `${this.base}/${value}`;
}
